import React from "react";
import { Link } from "react-router-dom";
import { Routes } from "../../app/route/RoutesConfig";

export interface InboundTrailerProps {
  trailerNumber: string | number;
  inboundManifestNumber?: string | number | null;
  terminalNumber?: number | null;
  className?: string;
}

function formatTrailerNumber(trailerNumber: string | number): string {
  const raw = String(trailerNumber).trim();
  if (!raw) return "—";
  const normalized = raw.toUpperCase();
  return normalized.startsWith("TL-") ? normalized : `TL-${normalized}`;
}

const InboundTrailer: React.FC<InboundTrailerProps> = ({
  trailerNumber,
  inboundManifestNumber,
  terminalNumber,
  className,
}) => {
  const displayValue = formatTrailerNumber(trailerNumber);

  if (inboundManifestNumber != null && terminalNumber != null) {
    return (
      <Link
        className={`xgs-table-link-cell${className ? ` ${className}` : ""}`}
        to={`/${terminalNumber}${Routes.freights.inbound}?manifestNumber=${encodeURIComponent(String(inboundManifestNumber))}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {displayValue}
      </Link>
    );
  }

  return <span className={className}>{displayValue}</span>;
};

export default InboundTrailer;
